import { vueConfig } from '../js/configs'
import { store } from '../js/configs/store'

import 'bootstrap/dist/css/bootstrap.min.css'
import '../vendors/all.min.css' // Font Awesome Free 5.15.4
import '~templates/css/icomoon/style.css' // Icomoon
import '~templates/css/style.css'

import 'intersection-observer'

import $ from 'jquery'
window.$ = $
window.jQuery = $

import 'popper.js'
import 'bootstrap/js/dist/util'
import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/tooltip'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/popover'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/carousel'
import 'bootstrap/js/dist/tab'
import 'bootstrap/js/dist/alert'
import 'bootstrap/js/dist/button'

import { createApp } from 'vue'
import VueCookies from 'vue-cookies'
import VueSkokka from './libs/vue-skokka'
import VLazyImage from 'v-lazy-image/v2'

import './utils/polyfills'

const app = createApp(vueConfig)
// Configure Vue 3 global properties for delimiters and compatibility
app.config.compilerOptions.delimiters = ['[[', ']]']
app.config.compilerOptions.whitespace = 'preserve'
app.config.compilerOptions.isCustomElement = (tag) => ['strike'].includes(tag)

app.use(store)
app.use(VueCookies)
app.use(VueSkokka)
app.component('VLazyImage', VLazyImage) // register component globally

app.mount('#app')
